import GolfCover from 'app/images/rapidFire/cover-golf.jpg';
import NFLCover from 'app/images/rapidFire/cover-nfl.jpg';
import NRLCover from 'app/images/rapidFire/cover-nrl.jpg';
import AFLCover from 'app/images/rapidFire/cover-afl.jpg';
import NBACover from 'app/images/rapidFire/cover-nba.jpg';
import GolfCoverMobile from 'app/images/rapidFire/cover-golf-mobile.jpg';
import NFLCoverMobile from 'app/images/rapidFire/cover-nfl-mobile.jpg';
import NRLCoverMobile from 'app/images/rapidFire/cover-nrl-mobile.jpg';
import AFLCoverMobile from 'app/images/rapidFire/cover-afl-mobile.jpg';
import NBACoverMobile from 'app/images/rapidFire/cover-nba-mobile.jpg';

// eslint-disable-next-line import/prefer-default-export
export const rapidFireSportIdAssetsMapping = [
  {
    sportId: 1,
    name: 'nrl',
    icon: 'rugby-league',
    cover: NRLCover,
    mobileCover: NRLCoverMobile
  },
  {
    sportId: 2,
    name: 'nfl',
    icon: 'american-football',
    cover: NFLCover,
    mobileCover: NFLCoverMobile
  },
  {
    sportId: 3,
    name: 'cricket',
    icon: 'cricket'
  },
  {
    sportId: 4,
    name: 'cricket',
    icon: 'cricket'
  },
  {
    sportId: 5,
    name: 'cricket',
    icon: 'cricket'
  },
  {
    sportId: 6,
    name: 'cricket',
    icon: 'cricket'
  },
  {
    sportId: 7,
    name: 'nba',
    icon: 'basketball',
    cover: NBACover,
    mobileCover: NBACoverMobile
  },
  {
    sportId: 8,
    name: 'afl',
    icon: 'australian-football',
    cover: AFLCover,
    mobileCover: AFLCoverMobile
  },
  {
    sportId: 9,
    name: 'soccer',
    icon: 'soccer'
  },
  {
    sportId: 10,
    name: 'kabaddi',
    icon: 'kabaddi'
  },
  {
    sportId: 11,
    name: 'ice-hockey',
    icon: 'ice-hockey'
  },
  {
    sportId: 12,
    name: 'golf',
    icon: 'golf',
    cover: GolfCover,
    mobileCover: GolfCoverMobile
  },
  {
    sportId: 13,
    name: 'baseball',
    icon: 'baseball'
  },
  {
    sportId: 14,
    name: 'horse',
    icon: 'horse'
  },
  {
    sportId: 15,
    name: 'esports',
    icon: 'esports'
  }
];
